import { Injectable } from '@angular/core';
import { AppConfigService } from '../../app.config';
import { UserSessionService } from './user-session.service';
import { takeUntil } from 'rxjs/operators';
import { DestroyRxComponent } from '../../components/destroy-rx/destroy-rx.component';
import { AppConfig } from '../models/appConfig';

@Injectable({ providedIn: 'root' })
export class RouterService extends DestroyRxComponent {
    private appConfig: AppConfig;
    private session!: string;

    /**
     * Sets the app configs from the config file and constructs the pipeline to set the current session on session
     * change.
     * @param config Service providing the app configs.
     * @param session Service providing the session$ observable.
     */
    constructor(config: AppConfigService, session: UserSessionService) {
        super();
        this.appConfig = config.getConfig();
        session.session$
            .pipe(takeUntil(this.destroy$))
            .subscribe((current) => (this.session = current.name));
    }

    /**
     * Provides an api url with the environment's base api url, tenant, session,
     * and controller if supplied.
     * @param controller an optional controller name to target. (default: '')
     * @param tenantOnly an optional flag to exclude the session. (default: false)
     */
    getApiUrl(controller: string = '', tenantOnly: boolean = false): string {
        let [tenant, session] = this.getTenantAndSession();
        session = tenantOnly ? '' : `${session}/`;
        return this.getApiBaseUrl(`${tenant}/${session}${controller}`);
    }

    /**
     * Get the base web api url with the given segments appended.
     * @param segments A single string containing all segments.
     */
    getApiBaseUrl(segments: string = '') {
        return `${this.appConfig.apiUrl}${segments}`;
    }

    /**
     * Tries to pull the tenant and session from the current route.
     * @returns The tenant and session, if present and valid; otherwise, the default.
     */
    getTenantAndSession = (): [string, string] => [
        this.appConfig.tenant,
        this.session,
    ];
}
